import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';
import { CountryState } from '../../../common/components/SearchHeader/constants';
import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { useHannibalQuery } from '../../../common/schema/hannibal/HannibalContext';
import { SuburbListDocument } from '../../../common/schema/hannibal/types.generated';
import { parseToEnum } from '../../../common/util/parseToEnum';
import { SuburbLinks } from './SuburbLinks';

interface Props {
  filters: FilterChoice;
  state: string;
  isSidebar?: boolean;
}

export const StateSuburbLinks = ({ filters, state, isSidebar = false }: Props) => {
  const { data } = useHannibalQuery(SuburbListDocument, { variables: { state } });

  const suburbs = data?.searchSuburbsByName.suburbs;

  const sorted = useMemo(
    () =>
      sortBy(suburbs, it => it.name).map(suburb => ({
        suburb: {
          name: suburb.name,
          postcode: suburb.postcode,
          state: parseToEnum(suburb.state, CountryState) ?? undefined,
        },
      })),
    [suburbs],
  );

  return <SuburbLinks filters={filters} locations={sorted ?? []} isSidebar={isSidebar} />;
};
